// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_5p-0";